/* eslint-disable no-console */
import { isInteger } from './utils';

/**
 * Enum association to error levels
 * @type {Object}
 */
export const Level = {
  none: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  log: 4,
  trace: 100,
};
/**
 * Noop style function, to bind meaningless calls to
 */
const noop = () => {};

/**
 * The amount of logging amount, can be set by number or enum
 * @type {Number}
 */
let logLevel = Level.warn;

/**
 * Exported version of the logger containing the simple logger utility
 * Use with setLevel to indicate logginess
 * Defaults to NONE, which means only .log will do something
 * @type {Object}
 */
const Logger = {
  error: noop,
  warn: noop,
  info: noop,
  debug: noop,
  trace: noop,
  log: noop,
};

Logger.logWithLevel = (level, ...msg) => {
  const entry = Object.entries(Level).find(([, value]) => value === level);
  if (!entry) {
    console.error('Unexpected log level', level);
    return;
  }

  const [levelName] = entry;

  Logger[levelName](...msg);
};

/**
 * Log level setter
 * Allows you to set Loglevels based on number or ENUM of Level
 * @param newLogLevel
 */
Logger.setLevel = (newLogLevel) => {
  if (isInteger(newLogLevel)) {
    logLevel = newLogLevel;
  } else {
    console.error('Invalid log level, defaulting to WARN');
    logLevel = Level.warn;
  }

  Logger.error = (logLevel >= Level.error) ? console.error.bind(console) : noop;
  Logger.warn = (logLevel >= Level.warn) ? console.warn.bind(console) : noop;
  Logger.info = (logLevel >= Level.info) ? console.info.bind(console) : noop;
  Logger.debug = (logLevel >= Level.debug) ? console.debug.bind(console) : noop;
  Logger.trace = (logLevel >= Level.trace) ? console.trace.bind(console) : noop;
  Logger.log = (logLevel >= Level.log) ? console.log.bind(console) : noop;
};

export default Logger;
